import type {FullTeamGrid} from './grid/full';
import type {TeamMember} from './member';

interface TeamElements {
	item: HTMLLIElement;
	link: HTMLAnchorElement;
}

export class Team {
	public readonly members: TeamMember[] = [];
	public readonly hash: string;
	private readonly elements: TeamElements = {
		item: document.createElement('li'),
		link: document.createElement('a')
	};

	constructor(private readonly grid: FullTeamGrid, public readonly id: number, public readonly name: string) {
		this.hash = '/' + (this.name === grid.defaultTeam ? '' : name.replace(/\s+/g, '-').replace(/[^\w-]+/, '').toLowerCase());
		this.elements.item.append(this.elements.link);
		this.elements.link.innerText = this.name;
		this.elements.link.href = '#' + this.hash;
	}

	public sort(): void {
		this.members
			.sort((a, b) => a.sortableName.localeCompare(b.sortableName))
			.sort((a, b) => a.getOrder(this) - b.getOrder(this));
	}

	public addToList(list: HTMLUListElement): void {
		list.append(this.elements.item);
	}

	public checkActive(): void {
		this.elements.item.classList.toggle('active', this.grid.selected === this);
	}
}
